import { TransactionStatus } from '../types/payment.types'

// OCP = One-Click Payment
export const PomResponseCodes = {
  // Completed
  '00': 'Payment successful',
  '110': 'Payment details are sent for wire transfer',
  '200': 'Mandate successfully signed',
  '300': 'Successful authorization – deferred sales (amount reserved).',
  'buckaroo.190': 'OCP Payment successful',
  // Processing
  '100': 'The transaction is being processed / scheduled.',
  // Refused
  '03': 'Your payment has been canceled by the beneficiary.',
  '05': 'The transaction has been rejected by the payment service provider.',
  '12': 'The transaction request could not be validated. The payment was not executed.',
  '17': 'Buyer cancellation.',
  '90': 'Some technical failure prevented the completion of the transaction. Wait a few minutes and try again later.',
  '99': 'The payment request failed.',
  '101': 'Payment method was suspended on POM side.',
  '201': 'Mandate signing not successful.',
  '301': 'Unsuccessful authorization (failed or canceled) – deferred sales (no amount reserved).',
  'buckaroo.description.V002': 'Expired card',
  'buckaroo.description.E100': 'Do not honor',
  'buckaroo.description.E101': 'Expired card',
  'buckaroo.description.E106': 'Card blocked - Allowable number of PIN tries exceeded',
  'buckaroo.description.E110': 'Invalid amount',
  'buckaroo.description.E111': 'Invalid card number (no such number)',
  'buckaroo.description.E115': 'Requested Function not supported',
  'buckaroo.description.E116': 'Not sufficient funds',
  'buckaroo.description.E118': 'No card record',
  'buckaroo.description.E119': 'Transaction not permitted to cardholder',
  'buckaroo.description.E120': 'Transaction not permitted to terminal',
  'buckaroo.description.E125': 'Card not effective / not activated',
  'buckaroo.description.E129': 'Suspected counterfeit card',
  'buckaroo.description.E181': 'Invalid BEPAF',
  'buckaroo.description.E187': 'Card Periodic limit exceeded',
  'buckaroo.description.E188': 'Card Daily limit exceeded',
  'buckaroo.description.E189': 'Account Periodic limit exceeded',
  'buckaroo.description.E190': 'Account Daily limit exceeded',
  'buckaroo.description.E192': 'Card Not affected (card not yet linked to an account)',
  'buckaroo.description.E193': 'Card Disaffected (or deactivated)',
  'buckaroo.description.E197': 'Issuer in Opposition',
  'buckaroo.description.E198': 'Wallet-initiated payment refused / 3DSecure required',
  'buckaroo.description.E208': 'Lost card, Pick-up if ATM',
  'buckaroo.description.E209': 'Stolen card, Pick-up if ATM',
  'buckaroo.description.E211': 'Card in Opposition, Pickup if ATM',
  'buckaroo.description.E212': 'Account in Opposition, Pickup if ATM',
  'buckaroo.description.E902': 'Invalid transaction',
  'buckaroo.description.E909': 'System malfunction',
  'buckaroo.description.E912': 'The payment service is currently unavailable',
  'buckaroo.description.E942': 'Time-out on the response to the authorization request message',
  'buckaroo.description.E946': 'Transaction aborted by the acquirer for its own reason',
}

/**
 * Check the POM response code and return the status and reason
 * @param code - The POM response code
 * @returns The status and reason
 */
export const getPomTransactionStatus = (code?: string | null): { status: TransactionStatus; reason: string } | null => {
  if (!code) {
    return null
  }

  const reason = PomResponseCodes[code as keyof typeof PomResponseCodes]
  let status: TransactionStatus

  if (code === '00' || code === '110' || code === '200' || code === '300' || code === 'buckaroo.190') {
    status = TransactionStatus.COMPLETED
  } else if (code === '100') {
    status = TransactionStatus.PROCESSING
  } else {
    status = TransactionStatus.REFUSED
  }

  return { status, reason }
}
